import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API, withCredentials: true });

const NO_RETRY = ["/auth/refresh", "/auth/login", "/auth/register", "/auth/session"];
let refreshing = null;

export const refreshSession = () => {
  refreshing = refreshing || api.post("/auth/refresh").finally(() => { refreshing = null; });
  return refreshing;
};

api.interceptors.response.use(
  (r) => r,
  async (err) => {
    const cfg = err.config || {};
    if (err.response?.status === 401 && !cfg._retry && !NO_RETRY.some((p) => cfg.url?.includes(p))) {
      cfg._retry = true;
      try {
        await refreshSession();
        return api(cfg);
      } catch (_) { /* fallthrough */ }
    }
    if (err.response?.status === 402 && !cfg.url?.includes("/billing/") && window.location.pathname !== "/subscribe"
      && /card on file to start/i.test(err.response?.data?.detail || "")) window.location.assign("/subscribe");
    return Promise.reject(err);
  }
);

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const errMsg = (e) => formatApiErrorDetail(e?.response?.data?.detail) || e.message;

const sleep = (ms) => new Promise((r) => setTimeout(r, ms));

export async function pollJob(pid, onEvent) {
  let fails = 0;
  for (;;) {
    let data;
    try {
      ({ data } = await api.get(`/projects/${pid}/job`));
      fails = 0;
    } catch (e) {
      if (++fails > 6) throw e;
      await sleep(1500 * fails);
      continue;
    }
    if (data.status === "running") onEvent({ type: "text", text: data.text || "" });
    else if (data.status === "done") return onEvent({ type: "plan", ...data });
    else if (data.status === "error") return onEvent({ type: "error", message: data.error });
    else if (data.status === "needs_payment") return onEvent({ type: "needs_payment", ...data });
    else return;
    await sleep(1200);
  }
}

export async function streamChat(pid, message, onEvent) {
  await api.post(`/projects/${pid}/chat`, { message });
  await pollJob(pid, onEvent);
}

export async function downloadFile(path, filename) {
  const { data } = await api.get(path, { responseType: "blob" });
  const url = URL.createObjectURL(data);
  const a = document.createElement("a");
  a.href = url; a.download = filename;
  document.body.appendChild(a); a.click(); a.remove();
  URL.revokeObjectURL(url);
}
